import {
  LOGIN_REQUESTING,
  LOGIN_CHANGE_PASSWORD,
  LOGIN_CHANGE_EMAIL,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  FETCH_RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  LOGIN_WITH_FACEBOOK_REQUESTING,
  RESET_PASSWORD_ERROR,
} from "./constants";
import { SIGNUP_SUCCESS } from "../signup/constants";
import i18n from "../../i18n";
import { ILoginReducer } from "./types";

const initialState: ILoginReducer = {
  requesting: false,
  successful: false,
  passwordResetError: "",
  resetPasswordSent: false,
  passwordError: "",
  email: "",
  password: "",
  messages: "",
  error: "",
};

const reducer = function signupReducer(
  state: ILoginReducer = initialState,
  action,
): ILoginReducer {
  switch (action.type) {
    case LOGIN_REQUESTING:
    case LOGIN_WITH_FACEBOOK_REQUESTING:
      return {
        ...state,
        requesting: true,
        successful: false,
        error: "",
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        requesting: false,
        successful: true,
      };

    case SIGNUP_SUCCESS: {
      return {
        ...initialState,
        requesting: false,
        successful: true,
      };
    }

    case LOGIN_CHANGE_EMAIL:
      return {
        ...state,
        error: "",
        email: action.payload,
      };

    case LOGIN_CHANGE_PASSWORD:
      return {
        ...state,
        error: "",
        password: action.payload,
      };

    case LOGIN_ERROR: {
      const { message } = action.error;
      const error = i18n.t(`error-${message}`);
      return {
        ...state,
        requesting: false,
        successful: false,
        resetPasswordSent: false,
        error,
      };
    }

    case LOGOUT:
      return initialState;

    case FETCH_RESET_PASSWORD: {
      return {
        ...state,
        requesting: true,
        resetPasswordSent: false,
        passwordResetError: "",
      };
    }

    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        requesting: false,
        resetPasswordSent: true,
        passwordResetError: "",
      };
    }

    case RESET_PASSWORD_ERROR: {
      return {
        ...state,
        requesting: false,
        passwordResetError: i18n.t("password-reset-error"),
      };
    }

    default:
      return state;
  }
};

export default reducer;
